"use strict";

exports.__esModule = true;
exports.default = IconSuccessSimple;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

var _ = _interopRequireDefault(require("./"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _ref =
/*#__PURE__*/
(0, _core.jsx)("g", null, (0, _core.jsx)("path", {
  d: "M12 3c4.968 0 9 4.032 9 9s-4.032 9-9 9-9-4.032-9-9 4.032-9 9-9z"
}));

/* eslint-disable prettier/prettier */
function IconSuccessSimple(props) {
  var iconProps = _objectSpread({
    rtl: false
  }, props);

  return (0, _core.jsx)(_.default, iconProps, _ref);
}

IconSuccessSimple.displayName = 'IconSuccessSimple';
IconSuccessSimple.category = 'alert';